// main.js
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import VueHtmlToPaper from "vue-html-to-paper";
import Dayjs from "vue-dayjs";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import VueSSE from "vue-sse";

// >>> NOVO: helper unificado de env/versão (runtime > build)
import { getAppVersion } from "./envRuntime";

// Canonicaliza a origem em dev para evitar CORS intermitente
if (location.hostname === "127.0.0.1") {
  const url =
    "http://localhost:8080" +
    location.pathname +
    location.search +
    location.hash;
  location.replace(url);
}

Vue.use(VueSSE);
Vue.use(VueTheMask);
Vue.use(money);

Vue.use(Dayjs, {
  lang: "pt",
  filters: { ago: "ago" },
});

Vue.config.productionTip = false;

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
  styles: ["./assets/print.css"],
};
Vue.use(VueHtmlToPaper, options);

// -----------------------------
// LIMPEZA POR VERSÃO (ANTES DA STORE) — usando helper
// -----------------------------
const APP_VERSION = getAppVersion();
console.debug("[APP] version =", APP_VERSION);

// -----------------------------
// CARREGAR STORE/ROUTER/PLUGINS APÓS LIMPAR
// -----------------------------
// use require para garantir ordem de avaliação no webpack
const store = require("./store/store").default;
const router = require("./router").default;

// plugins que podem depender da store (carregar depois da limpeza)
require("./plugins/axios");
require("./plugins/http");
require("./plugins/notify");
require("./plugins/loading");

// service worker por último (não depende da store, mas ok ficar aqui)
require("./registerServiceWorker");

// Reload automático quando o SW novo assumir e ping de update no load
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!window.__reloadedBySW) {
      window.__reloadedBySW = true;
      window.location.reload();
    }
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistration?.()
      .then((reg) => reg?.update?.())
      .catch(() => {});
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
